module.exports = __webpack_public_path__ + "img/16_lisa_h.d108584c.png";